import "./App.css";
import "./tailwindcss.css";
import Approuter from "./AppRouter";
import { store } from "./reducers/Store";
import { Provider } from "react-redux";
import { Toaster } from "react-hot-toast";
import { useEffect, useState } from "react";
import { ApolloProvider } from "@apollo/client";
import client from "./graphql/client";
import { MessageProvider } from "./contexts/MessageContext";
import { handleUrlAuthentication, hasUrlAuthentication } from "./utils/urlAuthHandler";

function App() {
  const [isAuthenticating, setIsAuthenticating] = useState(false);

  // Handle URL authentication on app start
  useEffect(() => {
    const handleUrlAuth = async () => {
      if (hasUrlAuthentication()) {
        setIsAuthenticating(true);
        console.log("🔄 Detected URL authentication parameters");

        try {
          const authSuccess = await handleUrlAuthentication();

          if (authSuccess) {
            console.log("✅ URL authentication completed successfully");
            // Optionally redirect to dashboard or refresh the page
            window.location.href = "/";
          } else {
            console.log("❌ URL authentication failed");
          }
        } catch (error) {
          console.error("URL authentication error:", error);
        } finally {
          setIsAuthenticating(false);
        }
      }
    };

    handleUrlAuth();
  }, []);

  //Disable mouse wheel behaviour in input tag globally
  useEffect(() => {
    const handleWheel = (event) => {
      if (event.target.type === "number") {
        event.preventDefault();
      }
    };

    document.addEventListener("wheel", handleWheel, { passive: false });

    return () => {
      document.removeEventListener("wheel", handleWheel);
    };
  }, []);

  // Show loading screen while handling URL authentication
  if (isAuthenticating) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-gray-50">
        <div className="text-center">
          <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-blue-600 mx-auto mb-4"></div>
          <h2 className="text-lg font-medium text-gray-900">Authenticating...</h2>
          <p className="text-gray-600">Please wait while we log you in</p>
        </div>
      </div>
    );
  }

  return (
    <ApolloProvider client={client}>
      <Provider store={store}>
        <MessageProvider>
          <div className="">
            <Approuter />
            <Toaster position="bottom-right" />
          </div>
        </MessageProvider>
      </Provider>
    </ApolloProvider>
  );
}

export default App;
